export default function CTASection() {
  return (
    <section className="flex flex-col md:flex-row min-h-[420px]">
      <div className="md:w-1/2 relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20product%20collage%20with%20various%20clothing%20items%20and%20accessories%20artistically%20arranged%20on%20soft%20textured%20cream%20background%2C%20warm%20natural%20lighting%2C%20clean%20editorial%20style%2C%20terracotta%20olive%20green%20and%20sand%20tones%2C%20sophisticated%20European%20aesthetic%2C%20vertical%20composition%20with%20organic%20flow%20and%20dried%20botanicals&width=900&height=700&seq=cta-left-v2-01&orientation=portrait&nocache=true"
          alt="Itaobuy Spreadsheet products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/30"></div>
        <div className="absolute bottom-8 left-8">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            Buy
            <br />
            Itaobuy
            <br />
            Now
          </h2>
        </div>
      </div>

      <div className="md:w-1/2 bg-background-50 flex items-center justify-center py-12 md:py-0 px-6 md:px-12">
        <div className="max-w-md text-center">
          <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Itaobuy Sheet
            <br />
            Buy It Now
          </h3>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            Pronto a scoprire il mondo di Itaobuy Spreadsheet? Accedi alla piattaforma completa
            e inizia subito a esplorare tutte le categorie di prodotti disponibili. Risparmia tempo
            e trova esattamente ci\u00f2 che cerchi con la nostra guida.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-6 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Acquista ora
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}